import { createSelector } from 'reselect'

import {
  createSelectorWithPath,
  labelSelectorFunc,
  entitiesSelector
} from 'helpers/ComponentSelectorUtil'
import { formFilterPairs } from '../../../components/custom/AddPopup/AddPopupUtil'

const sourcesSelectorFunc = state => state.sources
const valuesSelectorFunc = state => state.values
const segmentSelectorFunc = state => state.projectOverview.segment

const popupSelectorFunc = state => state.togglePopup
const configSelectionSelectorFunc = state => state.configSelection
const configSourceSelectorFunc = state => state.configSource
const archSelectorFunc = state => state.archFilter
const brandSelectorFunc = state => state.brandFilter
const classSelectorFunc = state => state.classFilter
const curConfigSelectorFunc = state => state.curConfig


const sourcesSelectorHoc = (sourcesSelector) => (
  createSelector(
    entitiesSelector,
    sourcesSelector,
    (entities, refs) => refs.map(({id, type}) => {
      const source = entities[type][id]
      return { ...source }
    })
  )
)

const filteredSourcesSelectorHoc = (valuesSelector, sourcesSelector) => (
  createSelector(
    valuesSelector,
    sourcesSelector,
    (values, sources) => {
      const ids = values.map(({id}) => id)
      return sources.filter(({id}) => !ids.includes(id))
    }
  )
)

const filterPairsSelectorHoc = (sourcesSelector, curConfigSelector) => (
  createSelector(
    sourcesSelector,
    curConfigSelector,
    (sources, curConfig) => formFilterPairs({
      architecture: 'Architecture',
      brand: 'Brand',
      classification: 'Classification',
    }, sources, curConfig)
  )
)

export default (pathName, uiPath) => {
  const withPath = createSelectorWithPath(pathName)
  const withUiPath = createSelectorWithPath(uiPath)

  const valuesSelector = withPath(valuesSelectorFunc)
  const labelSelector = withPath(labelSelectorFunc)
  const sourcesSelectorRef = withPath(sourcesSelectorFunc)
  const notebookConfigsSelector = withPath(valuesSelectorFunc)
  const segmentSelector = segmentSelectorFunc

  const sourcesSelector = sourcesSelectorHoc(sourcesSelectorRef)
  const filteredSourcesSelector = filteredSourcesSelectorHoc(valuesSelector, sourcesSelector)

  const togglePopupSelector = withUiPath(popupSelectorFunc)
  const configSelectionSelector = withUiPath(configSelectionSelectorFunc)
  const configSourceSelector = withUiPath(configSourceSelectorFunc)
  const archSelector = withUiPath(archSelectorFunc)
  const brandSelector = withUiPath(brandSelectorFunc)
  const classSelector = withUiPath(classSelectorFunc)
  const curConfigSelector = withUiPath(curConfigSelectorFunc)

  const filterPairsSelector = filterPairsSelectorHoc(filteredSourcesSelector, curConfigSelector)

  return {
    labelSelector,
    filteredSourcesSelector,
    notebookConfigsSelector,
    segmentSelector,
    configSelectionSelector,
    configSourceSelector,
    togglePopupSelector,
    archSelector,
    brandSelector,
    classSelector,
    curConfigSelector,
    filterPairsSelector,
  }
}
